module.exports = __webpack_public_path__ + "v.no1.7d5b9349.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/v.no1.jpg
// module id = sgxf
// module chunks = 0